import { useCallback, useState } from "react";
import useFetch from "../../hooks/useFetch";
import { useShowMessage } from "../Common/showMessage";

function useGetTransactions() {
  const [fetchWrapper] = useFetch();
  const showMessage = useShowMessage();
  const [transactionLoading, setTransactionLoading] = useState(false);

  const getTransactions = useCallback(
    (selectDates, setTransactions) => {
      fetchWrapper({
        endpoint_url: "transaction/getTransactions",
        params: {
          start_date: selectDates[0],
          end_date: selectDates[1],
        },
        setLoading: setTransactionLoading,
        onSuccess: (fetch_output) => {
          if (!("error" in fetch_output)) {
            let data = fetch_output["data"];
            setTransactions(data);
          } else {
            showMessage({ message: "Failed to get Transactions data." });
          }
        },
        onFetchError: () =>
          showMessage({ apiType: "fetch", message: "Get Transactions" }),
        onResponseError: () =>
          showMessage({ apiType: "response", message: "Get Transactions" }),
      });
    },
    [fetchWrapper]
  );

  return { getTransactions, transactionLoading };
}

export default useGetTransactions;
